import { createRouter, createWebHashHistory } from "vue-router";
import main from "../views/main.vue";
import { ElNotification } from "element-plus";

const routes = [
	{
		path: "/",
		name: "main",
		component: main,
		children: [
			{
				path: "/",
				name: "home",
				component: () => import("../views/home/home.vue"),
			},
			{
				path: "/task_browse",
				name: "task_browse",
				component: () => import("../views/budget/task_browse.vue"),
			},
			{
				path: "/cf",
				name: "cf",
				component: () => import("../views/temp/ysbz_cf.vue"),
			},
			{
				path: "/task_build",
				name: "task_build",
				component: () => import("../views/budget/task_build.vue"),
			},
			{
				path: "/mx",
				name: "mx",
				component: () => import("../views/temp/ysbz_mx.vue"),
			},
			{
				path: "/tm",
				name: "tm",
				component: () => import("../views/temp/ysbz_tm.vue"),
			},
			{
				path: "/tmt",
				name: "tmt",
				component: () => import("../views/temp/ysbz_tmt.vue"),
			},
			{
				path: "/dbzmx",
				name: "dbzmx",
				component: () => import("../views/temp/ysbz_dbzmx.vue"),
			},
			{
				path: "/dbztm",
				name: "dbztm",
				component: () => import("../views/temp/ysbz_dbztm.vue"),
			},
			{
				path: "/dbzbm",
				name: "dbzbm",
				component: () => import("../views/temp/ysbz_dbzbm.vue"),
			},
			{
				path: "/config_year",
				name: "config_year",
				component: () => import("../views/budget/config_year.vue"),
			},
			{
				path: "/config_right",
				name: "config_right",
				component: () => import("../views/budget/config_right.vue"),
			},
			{
				path: "/qxyhlb",
				name: "qxyhlb",
				component: () => import("../views/pzx/qxyhlb.vue"),
			},
			{
				path: "/qxbmlb",
				name: "qxbmlb",
				component: () => import("../views/pzx/qxbmlb.vue"),
			},
			{
				path: "/config_kjitem",
				name: "config_kjitem",
				component: () => import("../views/budget/config_kjitem.vue"),
			},
			{
				path: "/config_style",
				name: "config_style",
				component: () => import("../views/budget/config_style.vue"),
			},
			{
				path: "/bddy",
				name: "bddy",
				component: () => import("../views/pzx/bddy.vue"),
			},
			{
				path: "/bddyN",
				name: "bddyN",
				component: () => import("../views/pzx/bddyN.vue"),
			},
			{
				path: "/config_item",
				name: "config_item",
				component: () => import("../views/budget/config_item.vue"),
			},
			{
				path: "/config_kjtype",
				name: "config_kjtype",
				component: () => import("../views/budget/config_kjtype.vue"),
			},
			{
				path: "/task_split",
				name: "task_split",
				component: () => import("../views/budget/task_split.vue"),
			},
			{
				path: "/approve_check",
				name: "approve_check",
				component: () => import("../views/budget/approve_check.vue"),
			},
			{
				path: "/dwshmx",
				name: "dwshmx",
				component: () => import("../views/temp/yssp/dwshmx.vue"),
			},
			{
				path: "/dwshtm",
				name: "dwshtm",
				component: () => import("../views/temp/yssp/dwshtm.vue"),
			},
			{
				path: "/lssh",
				name: "lssh",
				component: () => import("../views/temp/yssp/lssh.vue"),
			},
			{
				path: "/lsshmx",
				name: "lsshmx",
				component: () => import("../views/temp/yssp/lsshmx.vue"),
			},
			{
				path: "/lsshtm",
				name: "lsshtm",
				component: () => import("../views/temp/yssp/lsshtm.vue"),
			},
			{
				path: "/dwpf",
				name: "dwpf",
				component: () => import("../views/temp/yssp/dwpf.vue"),
			},
			{
				path: "/dwpfmx",
				name: "dwpfmx",
				component: () => import("../views/temp/yssp/dwpfmx.vue"),
			},
			{
				path: "/dwpftm",
				name: "dwpftm",
				component: () => import("../views/temp/yssp/dwpftm.vue"),
			},
			{
				path: "/lspf",
				name: "lspf",
				component: () => import("../views/temp/yssp/lspf.vue"),
			},
			{
				path: "/lspfmx",
				name: "lspfmx",
				component: () => import("../views/temp/yssp/lspfmx.vue"),
			},
			{
				path: "/lspftm",
				name: "lspftm",
				component: () => import("../views/temp/yssp/lspftm.vue"),
			},
			{
				path: "/dwshrz",
				name: "dwshrz",
				component: () => import("../views/temp/rz/dwshrz.vue"),
			},
			{
				path: "/lsshrz",
				name: "lsshrz",
				component: () => import("../views/temp/rz/lsshrz.vue"),
			},
			{
				path: "/dwpfrz",
				name: "dwpfrz",
				component: () => import("../views/temp/rz/dwpfrz.vue"),
			},
			{
				path: "/lspfrz",
				name: "lspfrz",
				component: () => import("../views/temp/rz/lspfrz.vue"),
			},
			{
				path: "/ysrz",
				name: "ysrz",
				component: () => import("../views/temp/rz/ysrz.vue"),
			},
			{
				path: "/ysrzxz",
				name: "ysrzxz",
				component: () => import("../views/temp/rz/ysrzxz.vue"),
			},
			{
				path: "/rwzlshzt",
				name: "rwzlshzt",
				component: () => import("../views/temp/rwzlshzt.vue"),
			},
			{
				path: "/task_back",
				name: "task_back",
				component: () => import("../views/budget/task_back.vue"),
			},
			{
				path: "/add_apply",
				name: "add_apply",
				component: () => import("../views/budget/add_apply.vue"),
			},
			{
				path: "/add_approve",
				name: "add_approve",
				component: () => import("../views/budget/add_approve.vue"),
			},
			{
				path: "/add_return",
				name: "add_return",
				component: () => import("../views/budget/add_return.vue"),
			},
			{
				path: "/add_history",
				name: "add_history",
				component: () => import("../views/budget/add_history.vue"),
			},
			{
				path: "/move_apply",
				name: "move_apply",
				component: () => import("../views/budget/move_apply.vue"),
			},
			{
				path: "/move_approve",
				name: "move_approve",
				component: () => import("../views/budget/move_approve.vue"),
			},
			{
				path: "/move_return",
				name: "move_return",
				component: () => import("../views/budget/move_return.vue"),
			},
			{
				path: "/move_history",
				name: "move_history",
				component: () => import("../views/budget/move_history.vue"),
			},
			{
				path: "/move_apply",
				name: "move_apply",
				component: () => import("../views/budget/move_apply.vue"),
			},
			{
				path: "/move_approve",
				name: "move_approve",
				component: () => import("../views/budget/move_approve.vue"),
			},
			{
				path: "/config_shortcut",
				name: "config_shortcut",
				component: () => import("../views/budget/config_shortcut.vue"),
			},
			{
				path: "/prj_browse",
				name: "prj_browse",
				component: () => import("../views/budget/prj_browse.vue"),
			},
			{
				path: "/prj_create",
				name: "prj_create",
				component: () => import("../views/budget/prj_create.vue"),
			},
			{
				path: "/prj_release",
				name: "prj_release",
				component: () => import("../views/budget/prj_release.vue"),
			},
			{
				path: "/config_flow",
				name: "config_flow",
				component: () => import("../views/budget/config_flow.vue"),
				// component: () => impor../views/budget/config_style_0.vuevue"),
			},
			{
				path: "/bxjdym",
				name: "bxjdym",
				component: () => import("../views/budget/bxjdym.vue"),
			},
		],
	},
	{
		path: "/login",
		name: "login",
		component: () => import("../views/login/login.vue"),
	},
	{
		path: "/404",
		name: "404",
		component: () => import("@/views/noPage/404.vue"),
	},
	{
		path: "/linkLog",
		name: "linkLog",
		component: () => import("@/views/noPage/linkLog.vue"),
	},
	{
		path: "/:catchAll(.*)",
		redirect: "/404",
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

const whiteList = ["login", "linkLog"];
router.beforeEach((to, from, next) => {
	if (localStorage.getItem("token")) {
		next();
	} else {
		if (whiteList.indexOf(to.name) !== -1) {
			next();
		} else {
			ElNotification({
				title: "系统提示",
				message: "未登录，请登录",
				type: "error",
				duration: 3000,
			});
			next({ path: "/login" });
		}
	}
});
export default router;
